import axios from 'axios';
import { useEffect, useState } from 'react';
import { getVisitorLocation } from '../utils/visitorLocation';

export const useData = (url) => {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			try {
				// Fetch the region
				const { region } = await getVisitorLocation();

				// Fetch the data endpoints by region
				const response = await axios.get(`${url}?region=${region}`);
				const sourceURLs = response.data;

				// Fetch app data from different REST endpoints
				const singularData = await Promise.all(
					Object.entries(sourceURLs).map(async ([key, url]) => {
						const response = await axios.get(url);
						return { [key]: response.data };
					}),
				);

				const dataObject = singularData.reduce((acc, val) => ({ ...acc, ...val }), {});
				setData(dataObject);
			} catch (err) {
				setError(err);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, []);

	return { data, loading, error };
};
